<template>
    <div>
        <header class="slds-global-header_container">
            <div
                :class="colorClass"
                class="slds-global-header slds-grid slds-grid_align-spread slds-p-vertical_medium"
            >
                <div class="slds-global-header__item">
                    <div class="slds-global-header__logo"></div>
                </div>
                <div class="slds-global-header__item">
                    <ul class="slds-global-actions">
                        <li class="slds-global-actions__item slds-hide">
                            <button class="slds-button slds-global-actions__help slds-global-actions__item-action slds-text-color_inverse">
                                <span class="ma-icon ma-icon-question"></span>
                                <span class="slds-assistive-text">Help and Training</span>
                                Help
                            </button>
                        </li>
                        <li
                            v-if="store__loginState.isLoggedIn"
                            class="slds-global-actions__item ma-profile-menu"
                        >
                            <MAActionMenu :forceRight="true">
                                <button
                                    slot="button"
                                    class="slds-button"
                                    style="color: #182337"
                                >
                                    <span class="slds-button__icon ma-icon ma-icon-user"></span>
                                    {{ store__loginState.userId }}
                                    <span class="slds-button__icon ma-icon ma-icon-down"></span>
                                </button>

                                <MAActionMenuItem
                                    label="Logout"
                                    @click="logout()"
                                />
                            </MAActionMenu>
                        </li>
                        <li
                            v-else
                            class="slds-global-actions__item ma-profile-menu"
                        >
                            <a
                                slot="button"
                                class="slds-button slds-button_brand"
                                href="https://help.salesforce.com/articleView?id=salesforce_maps_intro.htm"
                                target="_blank"
                            >
                                <span class="slds-button__icon ma-icon ma-icon-info"></span>
                                About Salesforce Maps
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import MAActionMenu from '@mapanything/ma-lib/src/vue/components/MAActionMenu.vue';
import MAActionMenuItem from '@mapanything/ma-lib/src/vue/components/MAActionMenuItem.vue';

export default {
    name: 'UploadHeader',
    components: { MAActionMenu, MAActionMenuItem },
    props: { colorClass: { type: String, default: 'blue' } },
    data() {
        return {
        };
    },
    computed: {
        ...mapState({
            store__loginState: 'loginState'
        })
    },
    methods: {
        login() {
            window.location.replace('/api/login');
        },
        logout() {
            const API_URL = document.location.href;
            this.$http.get(`${API_URL}api/login/logout`).then(() => {
                // make call to logout
                this.store__loginState.isLoggedIn = false;
                this.store__loginState.userId = undefined;
            });
        }
    }
};
</script>

<style lang="scss">
.slds-global-header.white .slds-dropdown_actions a {
    color:#182337 !important;
}
</style>

<style lang="scss" scoped>
    .slds-global-header_container{
        position: relative;

        .slds-global-header {
            height: auto;
            box-shadow: none !important;

            &.blue {
                background-color: #CAE6F1;
                border-bottom: none;
            }
            &.white {
                background-color: white;
                border-bottom: 3px solid #00a2df;

                .slds-dropdown--actions a, .slds-dropdown_actions a {
                    color: #182337 !important;
                }
                .slds-global-actions .slds-global-actions__item.ma-profile-menu .slds-button {
                    color: #182337!important;
                }
            }

            .slds-global-header__logo {
                background-image: url('../assets/sf_maps_logo_RGB.svg');
            }

            .slds-global-actions__item-action:focus, .slds-global-actions__item-action:hover:not(:disabled) {
                color: #fafaf9;
            }
        }
    }

    .ma-profile-menu .slds-button {
        border-radius: 1rem;
    }

</style>
